// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */
import React from 'react';
import { ActionsWrapper, BottomBarWrapper, OuterWrapper, StyledTitleWrapper, TitleContainer, TitleWrapper } from './styled';
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */
var PageHeader = function PageHeader(_ref) {
  var innerRef = _ref.innerRef,
    breadcrumbs = _ref.breadcrumbs,
    actions = _ref.actions,
    bottomBar = _ref.bottomBar,
    children = _ref.children,
    id = _ref.id,
    _ref$disableTitleStyl = _ref.disableTitleStyles,
    disableTitleStyles = _ref$disableTitleStyl === void 0 ? false : _ref$disableTitleStyl,
    _ref$truncateTitle = _ref.truncateTitle,
    truncateTitle = _ref$truncateTitle === void 0 ? false : _ref$truncateTitle;
  return /*#__PURE__*/React.createElement(OuterWrapper, null, breadcrumbs, /*#__PURE__*/React.createElement(TitleWrapper, {
    truncateTitle: truncateTitle
  }, /*#__PURE__*/React.createElement(TitleContainer, {
    truncateTitle: truncateTitle
  }, disableTitleStyles ? children : /*#__PURE__*/React.createElement(StyledTitleWrapper, {
    ref: innerRef,
    truncateTitle: truncateTitle,
    id: id
  }, children)), actions && /*#__PURE__*/React.createElement(ActionsWrapper, null, actions)), bottomBar && /*#__PURE__*/React.createElement(BottomBarWrapper, null, " ", bottomBar, " "));
};
export default PageHeader;